import React from 'react';
import { Alert, Container } from 'cstar-react-primitives/lib/redux-form';

import errorMessages from './errorMessages';


const ErrorRefresh = () => (
    <Container hasSlimPadding>
        <Alert
            alertType="error"
            hasHeading
            heading={errorMessages.errorRefreshTitle}
            message={errorMessages.errorRefreshDescription}
        />
    </Container>
);

export default ErrorRefresh;
